import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { routeConfiguration } from '../../../../index';
import { createResourceLocatorString } from '../../../../util/routes';
import RegionCard from '../../../BasicUI/Cards/RegionCard';
import { withBaseComponent } from '../../hoc/withBaseComponent';

const destinations = [
  {
    title: 'Berlin',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/5ed05303bd/berlin.webp',
      alt: 'Lavendel Wiesen in Frankreich',
      title: 'Lavendel Wiesen in Frankreich',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'berlin',
  },

  {
    title: 'Hamburg',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x478/4f59deeafd/hamburg.webp',
      alt: 'Italy Coast',
      title: 'Italy Coast',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'hamburg',
  },
  {
    title: 'München',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/725b602969/muenchen.webp',
      alt: 'Splash of Germany Bayern Castle',
      title: 'Splash of Germany Bayern Castle',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'muenchen',
  },
  {
    title: 'Köln',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x962/989b92390f/koeln.webp',
      alt: 'City skyline of cologne',
      title: 'City skyline of cologne',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'koeln',
  },
  {
    title: 'Frankfurt',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x480/56622d2376/sinan-erg-xh7iycrfmfs-unsplash-_1_.webp',
      alt: 'City skyline of cologne',
      title: 'City skyline of cologne',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'frankfurt',
  },
  {
    title: 'Dortmund',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/97955b9f00/dortmund.webp',
      alt: 'Dortmunder Union Tower',
      title: 'Dortmunder Union Tower',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'dortmund',
  },
  {
    title: 'Nürnberg',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x427/2948c1d68d/markus-spiske-yeay6ua92rw-unsplash.webp',
      alt: 'wohnwagenstellplatz Nürnberg',
      title: 'wohnwagenstellplatz Nürnberg',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'nuernberg',
  },

  {
    title: 'Hannover',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x414/555826bb31/lu-moreno-ny2mrbjwroi-unsplash.webp',
      alt: 'view of hannover',
      title: 'view of hannover',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'hannover',
  },
  {
    title: 'Stuttgart',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x386/d65d0ccc6a/kumas_taverne-5tvikh12msa-unsplash.webp',
      alt: 'view of stuttgart',
      title: 'view of stuttgart',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'stuttgart',
  },
  {
    title: 'Salzburg',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x480/7fd9dbc7d7/alex-hufnagl-oexluu6sl2q-unsplash.webp',
      alt: 'view of salzburg',
      title: 'view of salzburg',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'salzburg',
  },
  {
    title: 'Rostock',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x427/e3c6c752ff/samuel-svec-fhkzznwqoby-unsplash-_1_.webp',
      alt: 'Coast of Rockstock',
      title: 'Coast of Rockstock',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'rostock',
  },
  {
    title: 'Dresden',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x428/508ee0e9e3/vasily-malygin-iwcoxmnnqbo-unsplash.webp',
      alt: 'wohnwagenstellplatz Dresden',
      title: 'wohnwagenstellplatz Dresden',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'dresden',
  },
  {
    title: 'Leipzig',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x427/37fea58ac0/dana-ward-r0t2nf-7drm-unsplash.webp',
      alt: 'wohnwagenstellplatz Leipzip',
      title: 'wohnwagenstellplatz Leipzip',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'leipzig',
  },
  {
    title: 'Wismar',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x427/563e594139/jan-bolz-nzr_tdo5_yu-unsplash.webp',
      alt: 'wohnwagenstellplatz Leipzip',
      title: 'wohnwagenstellplatz Leipzip',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'wismar',
  },
  {
    title: 'Bremerhaven',
    subtitle: 'Wohnwagenstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x431/80061315b5/free-nomad-rtuhxpdkv4c-unsplash.webp',
      alt: 'wohnwagenstellplatz Bremerhaven',
      title: 'wohnwagenstellplatz Bremerhaven',
    },
    slug: 'wohnwagenstellplatz',
    rest: 'bremerhaven',
  },
  // Add more destinations as needed
];

const StoryblokCitiesCaravanPreset = () => {
  const intl = useIntl();
  return (
    <Container
      maxWidth="xl"
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 6 }}
    >
      <Typography component="h2" sx={{ mb: 6 }} variant="h3">
        <FormattedMessage id="SectionCities.caravan.header" />
      </Typography>
      <Grid container justifyContent="center" spacing={4}>
        {destinations.map((destination, index) => {
          const link = createResourceLocatorString(
            'StoryblokPage',
            routeConfiguration(),
            { slug: destination.slug, rest: destination.rest },
            {},
            intl.locale,
          );

          return (
            <Grid key={index} size={{ lg: 4, md: 6, xs: 12 }}>
              <RegionCard
                image={destination.image}
                link={link}
                subtitle={destination.subtitle}
                title={destination.title}
              />
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default withBaseComponent(StoryblokCitiesCaravanPreset);
